<template>
    <div :class="itemClasses">
        <div class="card__name" v-html="cardName"></div>
        <div class="card__sale" v-if="shopPackage.is_sale && !event">{{ trans.get('ms:shop.sale') }}</div>
        <div class="card-behind__corner card-behind__corner-left" v-if="isJoker" v-html="jokerText"></div>
        <div class="card-behind__corner card-behind__corner-right" v-if="isJoker" v-html="jokerText"></div>
        <div class="card__title-last-chance" v-if="isLastChance">{{ trans.get('ms:shop.lc_we_have_an_offer_for_you') }}</div>

        <ElementTitle
            :shopPackage="shopPackage"
            :bonusAmount="bonusAmount"
            :amount="shopPackage.amount"
            :unit="shopPackage.unit"
            :type="shopPackage.type"
            :starter="!!shopPackage.is_starter"
        ></ElementTitle>

        <ElementPrice
            :price="price"
            :type="shopPackage.type"
            :starter="!!shopPackage.is_starter"
        ></ElementPrice>

        <ElementInfo :tags="shopPackage.tags"></ElementInfo>

        <ElementButton
            :buttonClass="buttonClass"
            :buttonLoading="buttonLoading"
            @buy="$emit('buy')"
        ></ElementButton>

        <div v-if="!shopPackage.is_promoted" class="card__icon">
            <i v-if="shopPackage.unit === 'coin' && shopPackage.is_starter" class="demo-icon icon-shuttle"></i>
            <i v-if="jokerIcon" class="demo-icon demo-icon icon-joker-cut-1"></i>
            <i v-if="isLastChanceIcon" class="demo-icon icon-marketing"></i>
            <i v-if="shopPackage.unit === 'coin' && shopPackage.is_best_seller" class="demo-icon icon-rate"></i>
            <img v-if="shopPackage.unit === 'coin' && shopPackage.is_sale && event" src="/img/viluu/payment/package_val.png" alt="">
            <i v-if="showSpeedArrowIcon" class="demo-icon icon-speed-arrow"></i>
        </div>
    </div>
</template>

<script>
import PackageMixin from './PackageMixin';
import ElementTitle from './ElementTitle';
import ElementPrice from './ElementPrice';
import ElementInfo from './ElementInfo';
import ElementButton from './ElementButton';

export default {
  name: 'DefaultPackage',
  mixins: [PackageMixin],
  components: { ElementButton, ElementInfo, ElementPrice, ElementTitle },
  computed: {
    event() {
      return false;
    },
    jokerIcon() {
      return this.shopPackage.unit === 'joker' && this.shopPackage.type !== 'last-chance';
    },
    itemClasses() {
      return {
        'buy-credits__item': true,
        'buy-credits__item--starter': this.shopPackage.is_starter,
        'buy-credits__item--promoted': this.shopPackage.is_promoted,
        'buy-credits__item--premium': this.shopPackage.is_best_seller,
        'buy-credits__item--sale': this.shopPackage.is_sale && !this.event,
        'buy-credits__item--sale-event': this.shopPackage.is_sale && this.event,
      };
    },
    cardName() {
      if (this.shopPackage.is_starter) {
        return this.trans.get('ms:shop.starter');
      } else if (this.shopPackage.is_sale && this.event) {
        return this.shopPackage.name;
      } else if (this.shopPackage.is_promoted) {
        return '<img src="/img/viluu/payment/promoted.svg">';
      } else {
        return this.shopPackage.name;
      }
    },
    isJoker() {
      return this.shopPackage.unit === 'joker' && !this.shopPackage.is_starter && this.shopPackage.type !== 'last-chance';
    },
    jokerText() {
      return '<span>J</span>oker';
    },
    isLastChance() {
      return this.shopPackage.unit === 'coin' && this.shopPackage.type === 'last-chance';
    },
    buttonClass() {
      return {
        'button__outline button__outline--white-hov-purple': this.shopPackage.is_best_seller || (this.shopPackage.is_sale && this.event),
        'button__fill': !this.shopPackage.is_best_seller && !(this.shopPackage.is_sale && this.event),
      };
    },
    isLastChanceIcon() {
      return (this.shopPackage.unit === 'joker' && this.shopPackage.type === 'last-chance') || (this.shopPackage.unit === 'coin' && this.shopPackage.type === 'last-chance');
    },
    showSpeedArrowIcon() {
      return this.shopPackage.unit === 'coin' && !this.shopPackage.is_starter && !this.shopPackage.is_best_seller && this.shopPackage.type !== 'last-chance';
    },
  },
};
</script>
